import { GETAJINDA, INSERTAGENDA, UPDATEAJINDA, DELETEAJINDA } from "../type";
const initialState = {
  inserAjenda: [],
  getAjenda: [],
  deleteAjenda: [],
  updateAjenda: [],
  loading: true,
};
const AjendaR = (state = initialState, action) => {
  switch (action.type) {
    case GETAJINDA:
      return {
        ...state,
        getAjenda: action.payload,
        loading: false,
      };
    case INSERTAGENDA:
      return {
        getAjenda: state.getAjenda,
        inserAjenda: action.payload,
        loading: false,
      };
    case DELETEAJINDA:
      return {
        getAjenda: state.getAjenda,
        deleteAjenda: action.payload,
        loading: false,
      };
    case UPDATEAJINDA:
      return {
        getAjenda: state.getAjenda,
        updateAjenda: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};
export default AjendaR;
